import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import styles from './SidebarNav.module.css'

class SidebarNav extends Component {
  state = {
    open: false,
  }

  toggleNav = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  handleClick = e => {
    //Only for mobile & when it's open.
    if (window.innerWidth < 992 && this.state.open) {
      if (!this.node.contains(e.target) || e.target.className.includes('list-item')) {
        this.toggleNav()
      }
    }
  }

  componentWillMount() {
    document.addEventListener('mouseup', this.handleClick, false)
  }

  render() {
    const { items, currentItem, title } = this.props
    const { open } = this.state

    return (
      <nav
        className={`${styles.nav} ${open ? styles.open : styles.closed}`}
        ref={node => (this.node = node)}
      >
        <h3 className={styles.title}>{title}</h3>
        <ol className={styles.list}>
          {items.map(item => (
            <li
              className={`${styles['list-item']} ${
                // eslint-disable-next-line no-nested-ternary
                item.nid === currentItem
                  ? item.avaliableTeacherOnly
                    ? styles['list-item-active-teacher']
                    : styles['list-item-active']
                  : ''
              }
              `}
              key={item.nid}
            >
              <Link
                to={`#${item.nid}`}
                className={`${styles.counter} ${styles.link}  ${
                  item.avaliableTeacherOnly
                    ? styles['list-item-link-teacher']
                    : styles['list-item-link']
                }`}
                onClick={this.handleClick}
              >
                <span className={styles['list-item-link-text']}>{item.title}</span>
              </Link>
            </li>
          ))}
        </ol>

        <button type='button' className={styles['toggle-nav']} onClick={this.toggleNav}>
          <FontAwesomeIcon icon={open ? faChevronLeft : faBars} />
        </button>
      </nav>
    )
  }
}

SidebarNav.propTypes = {
  items: PropTypes.array,
  currentItem: PropTypes.number,
  title: PropTypes.string,
}

export default SidebarNav
